import { Component, OnInit } from '@angular/core';
import { MainLayoutStore } from '../services/main.layout.store';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
})
export class BreadcrumbComponent implements OnInit {
  constructor(public layoutStore: MainLayoutStore, private router: Router, private route: ActivatedRoute) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        tap(() => {
          this.initBreadCrumbs();
        })
      )
      .subscribe();
    this.initBreadCrumbs();
  }

  ngOnInit() {}

  navigateToHome() {
    this.navigateTo('/dashboard');
  }

  navigateTo(url) {
    this.router.navigate([url]);
  }

  initBreadCrumbs() {
    this.layoutStore.resetBreadcrumbs();
    let currentRoute = this.route.root;
    let url = '';
    let lastTitle: string;
    do {
      const childrenRoutes = currentRoute.children;
      currentRoute = null;
      let tempBreadcrumb: string;

      childrenRoutes.forEach((routes) => {
        if (routes.outlet === 'primary') {
          const routeSnapshot = routes.snapshot;
          if (routeSnapshot.url.length > 0) {
            url += '/' + routeSnapshot.url.join('/');
          }
          if (routes.snapshot.data.breadcrumb !== undefined) {
            let status = true;
            if (routes.snapshot.data.status !== undefined) {
              status = routes.snapshot.data.status;
            }

            let icon = false;
            if (routes.snapshot.data.icon !== undefined) {
              icon = routes.snapshot.data.icon as boolean;
            }

            let title: '';
            if (routes.snapshot.data.title !== undefined) {
              title = routes.snapshot.data.title;
            }

            if (tempBreadcrumb !== routes.snapshot.data.breadcrumb && routes.snapshot.data.title !== lastTitle) {
              if (
                url
                  .split('/')
                  [url.split('/').length - 1].match(
                    this.router.url.split('/')[this.router.url.split('/').length - 1].split(';')[0]
                  )
              ) {
                this.layoutStore.state.breadcrumbs.push({
                  label: routes.snapshot.data.breadcrumb,
                  icon: icon,
                  status: status,
                  url: url,
                  title: title,
                  cursor: false,
                });
              } else {
                this.layoutStore.state.breadcrumbs.push({
                  label: routes.snapshot.data.breadcrumb,
                  icon: icon,
                  status: status,
                  url: url,
                  title: title,
                  cursor: true,
                });
              }
              lastTitle = routes.snapshot.data.title;
            }

            tempBreadcrumb = routes.snapshot.data.breadcrumb;
          }
          currentRoute = routes;
        }
      });
    } while (currentRoute);
  }
}
